import { createTheme } from "@material-ui/core/styles";
import AMS from './AMS'
//@ts-ignore
export default createTheme(AMS)